import { combineEpics } from 'redux-observable';
import { filter, ignoreElements, tap, take } from 'rxjs/operators';

import { loadConfigSuccess, pageChanged } from '../../../app/reducers';
import { offerSelected } from '../../../app/reducers/offer-selected';
import { preapproved } from '../../../app/reducers/preapproved';
import { RootEpic } from '../../../store/epics';
import { saveBusinessInfoTwo } from '../../application/reducers/business-info';
import { sendTQC05, loadAnalyticsDataSuccess } from '../reducers/analytics-data';

const sendTQC03Epic: RootEpic = (action$, state$, { api: { segment } }) =>
  action$.pipe(
    filter(saveBusinessInfoTwo.match),
    tap(() => segment.sendTQC03(state$.value)),
    ignoreElements(),
  );

const sendTQC06OnOfferSelectedEpic: RootEpic = (action$, _state$, { api: { segment } }) =>
  action$.pipe(
    filter(offerSelected.match),
    tap(({ payload: { offer } }) => {
      void segment.sendTQC06(offer);
    }),
    ignoreElements(),
  );

const sendTQC04OnPreapprovedEpic: RootEpic = (action$, state$, { api: { segment } }) =>
  action$.pipe(
    filter(preapproved.match),
    tap(({ payload: { offers, ...creditTerms } }) => segment.sendTQC04({ state: state$.value, creditTerms, offers })),
    ignoreElements(),
  );

const sendTQC05Epic: RootEpic = (action$, _state$, { api: { segment } }) =>
  action$.pipe(
    filter(sendTQC05.match),
    tap(({ payload }) => segment.sendTQC05(payload)),
    ignoreElements(),
  );

const sendDQC01Epic: RootEpic = (action$, state$, { api: { segment } }) =>
  action$.pipe(
    filter(loadAnalyticsDataSuccess.match),
    tap(({ payload: analyticsData }) => {
      void segment.sendDQC01({ analyticsData, state: state$.value });
    }),
    ignoreElements(),
  );

const sendPageEpic: RootEpic = (action$, _state$, { api: { segment } }) =>
  action$.pipe(
    filter(pageChanged.match),
    tap(() => segment.sendPage()),
    ignoreElements(),
  );

const loadAnalyticsEpic: RootEpic = (action$, _state$, { api: { segment } }) =>
  action$.pipe(
    filter(loadConfigSuccess.match),
    take(1),
    tap(({ payload: { segment: segmentConfig } }) =>
      segment.loadAnalytics({
        writeKey: segmentConfig.writeKey,
        cdnURL: segmentConfig.cdnUrl,
      }),
    ),
    ignoreElements(),
  );

export const segmentAnalyticsEpic = combineEpics(
  sendTQC03Epic,
  sendTQC06OnOfferSelectedEpic,
  sendTQC04OnPreapprovedEpic,
  sendTQC05Epic,
  sendDQC01Epic,
  sendPageEpic,
  loadAnalyticsEpic,
);
